import axios from 'axios'
import { BASE_URL } from './constants.js'

let getTokenFn = null

export const setTokenGetter = (fn) => {
  getTokenFn = fn
}

const api = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
})

api.interceptors.request.use(
  async (config) => {
    if (getTokenFn) {
      try {
        const token = await getTokenFn()
        if (token) {
          config.headers.Authorization = `Bearer ${token}`
        }
      } catch {
        console.error('Failed to get access token')
      }
    }
    return config
  },
  (error) => Promise.reject(error),
)

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      try { sessionStorage.clear() } catch {}
      window.location.href = '/login'
    }
    return Promise.reject(error)
  },
)

export default api
